<ng-container *ngIf="actividades && actividades.length > 0">
    <div [class.nocontainer]="esComplete" class="ui container" *ngIf="(!spinner && esComplete) || !esComplete">
        <app-header-component  [mission_id]="missionId" [esComplete]="esComplete" [score]='score' [title]='instruction' [ot]="ot"
            [estado]='state'>
        </app-header-component>
        <div id="DATA-PDF">
            <div style='overflow-x: auto;' style="margin-bottom: 2em;" *ngIf="ot && !esComplete">
                <table class="ui celled structured table unstackable">
                    <thead>
                        <tr>
                            <th colspan="2" class="center aligned">DATOS PRELIMINARES</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class='label'>CÓDIGO:<span class='negrita'>{{code}}</span></td>
                            <td class='label'>Estación:<span class='negrita'>{{station}}</span></td>


                        </tr>
                        <tr>
                            <td class='label '> OT:<span class='negrita'>{{ot}}</span></td>
                            <td class='label'>Sección:<span class='negrita'>{{section }}</span></td>

                        </tr>
                        <tr>
                            <td class='label'> Fecha:<span class='negrita'>{{when | date: 'dd/MM/yyyy' }}</span></td>
                            <td class='label'>Evaluó:<span class='negrita'>{{performer}}</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="ui divider " *ngIf="!esComplete"></div>


            <div *ngFor="let activity of actividades;index as i" class="container-protocol no-pdf">
                <div class="ui grid "
                    style="margin-top: 2em;display: flex;flex-direction: row;justify-content: space-between;">
                    <h2 class="title-actividad"> {{activity.title}}</h2>
                    <i *ngIf="activity.warning" class=" exclamation triangle icon pointer" [style.color]="'red'">
                    </i>
                    <i *ngIf="activity.out" class=" exclamation circle icon pointer" [style.color]="'red'">
                    </i>

                    <span class="puntaje" *ngIf=" !activity.infoIgnored">
                        Funcionalidad :

                        <span *ngIf="activity.score>=0" class="negrita"
                            [ngClass]="(activity.score<41 && activity.score>=0) ? 'font-error': (activity.score<71 && activity.score>40) ? 'font-no-alcanza':''">{{activity.score}}</span>
                        <span *ngIf="activity.score<0" class="negrita">N/A</span>
                        <span *ngIf="activity.score==null" class="negrita"><i class="clock outline icon"></i></span>

                    </span>
                </div>

                <ng-container *ngIf="instructionKey">
                    <div class="ui grid " style="margin-top: 1em;"
                        *ngFor="let item of activity.items;index as indexItem ">
                        <div class="sixteen wide column">
                            <div class="ui styled accordion " style="margin-top: 0.5em;">
                                <div [id]="'panel' + instructionKey + activity.seq + item.instruction + indexItem"
                                    class="title"
                                    (click)="activePanel(instructionKey + activity.seq + item.instruction + indexItem)">
                                    <i class="dropdown icon"></i>
                                    {{item.name}}
                                </div>

                                <div [id]="'content' + instructionKey + activity.seq + item.instruction + indexItem"
                                    class="content">
                                    <app-table-results *ngIf="activity" [nro]="ot" [data]="[item]"></app-table-results>
                                </div>
                            </div>

                        </div>
                    </div>
                </ng-container>

            </div>
            <div *ngFor="let activity of actividades; index as i" class="container-protocol si-pdf">
                <div class="ui grid "
                    style="margin-top: 2em;width: 100%;">
                    <h2 class="title-actividad"> {{activity.title}}</h2>
                    <i *ngIf="activity.warning" class=" exclamation triangle icon pointer" [style.color]="'red'">
                    </i>
                    <i *ngIf="activity.out" class=" exclamation circle icon pointer" [style.color]="'red'">
                    </i>

                    <span class="puntaje" style="color: gray;margin: 3px 2px" *ngIf=" !activity.infoIgnored">
                        Funcionalidad :

                          <span *ngIf="activity.score >=0" class="negrita"
                            [ngClass]="(activity.score<41 && activity.score>=0) ? 'font-error': (activity.score<71 && activity.score>40) ? 'font-no-alcanza':''">{{activity.score}}</span>
                        <span *ngIf="activity.score==null" class="negrita"><i class="clock outline icon"></i></span>
                        <span *ngIf="activity.score<0" class="negrita">N/A</span>

                    </span>
                </div>

                <div class="ui" style="margin-top: 0.5em;">
                    <div class="sixteen wide column " *ngFor="let item of activity.items;index as indexItem ">

                        <h4 class="title">
                            {{item.name}}
                        </h4>

                        <div>
                            <app-table-results *ngIf="activity" [nro]="ot" [data]="[item]"></app-table-results>
                        </div>
                    </div>
                </div>
                <div class="ui grid " style="margin-top: 1em;"
                    *ngFor="let group of activity.groups;index as indexItem ">
                    <div class="sixteen wide column">
                        <h2 class="subtitle"> {{ group.instruction}}</h2>
                        <div *ngFor="let item of group.items" style="margin-top: 0.5em;">
                            <div class="title ">
                                {{item.name}}
                            </div>

                            <div>
                                <app-table-results *ngIf="item" [nro]="ot" [data]="[item]"></app-table-results>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="ui grid" *ngIf="!esComplete">
            <div class="extra content">
                <button style="margin-top: 3em;" class="ui right labeled icon button button-filter primary"
                    (click)="goHome()">
                    <i class="home
                          icon"></i>
                    Volver
                </button>
            </div>
        </div>
    </div>
</ng-container>
<div *ngIf="spinner && esComplete" style="text-align:center;">
    <div class="ui active inline loader" style="margin:auto"></div>
    <p>Cargando datos de {{instruction}}</p>
</div>